export default "/_next/static/images/kimberly-blackwell-562e7d17a4b7fddc33cee730055d8c58.png";